import { Component, OnDestroy } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import _ from 'lodash';
import { Observable } from 'rxjs';
import { WellKnownIconsEnum } from 'src/app/helper/iconHelper';
import {
   ResetPasswordEditing,
   ChangeOwnPasswordNow,
   UpdateConfirmedPassword,
   UpdateCurrentPassword,
   UpdateNewPassword,
} from 'src/app/store/samwin/change-password/change-own-password.actions';
import { ChangeOwnPasswordState } from 'src/app/store/samwin/change-password/change-own-password.state';

@Component({
   selector: 'samweb-user-password',
   templateUrl: './user-password.component.html',
   styleUrls: ['./user-password.component.scss'],
})
export class UserPasswordComponent implements OnDestroy {
   @Select(ChangeOwnPasswordState.currentPassword)
   public currentPassword$: Observable<string>;

   @Select(ChangeOwnPasswordState.newPassword)
   public newPassword$: Observable<string>;

   @Select(ChangeOwnPasswordState.confirmedPassword)
   public confirmedPassword$: Observable<string>;

   @Select(ChangeOwnPasswordState.isNewPasswordSpecified)
   public isNewPasswordSpecified$: Observable<boolean>;

   @Select(ChangeOwnPasswordState.isNewPasswordConfirmed)
   public isNewPasswordConfirmed$: Observable<boolean>;

   @Select(ChangeOwnPasswordState.canChangePasswordNow)
   public canChangePasswordNow$: Observable<boolean>;

   @Select(ChangeOwnPasswordState.isResultAvailable)
   public isResultAvailable$: Observable<boolean>;

   @Select(ChangeOwnPasswordState.lastChangeSucceeded)
   public lastChangeSucceeded$: Observable<boolean>;

   @Select(ChangeOwnPasswordState.lastChangeMessage)
   public lastChangeMessage$: Observable<string>;

   public successIcon = WellKnownIconsEnum.SUCCESS.icon;
   public errorIcon = WellKnownIconsEnum.ERROR.icon;

   constructor(private store: Store) {
      // reset store
      this.store.dispatch(new ResetPasswordEditing());
   }

   ngOnDestroy(): void {
      // clear potentially stored passwords when leaving destroying the component (leaving the tab)
      this.store.dispatch(new ResetPasswordEditing());
   }

   public updateCurrentPassword(value: string) {
      this.store.dispatch(new UpdateCurrentPassword(value));
   }

   public updateNewPassword(value: string) {
      this.store.dispatch(new UpdateNewPassword(value));
   }

   public updateConfirmedPassword(value: string) {
      this.store.dispatch(new UpdateConfirmedPassword(value));
   }

   public changePasswordNow() {
      this.store.dispatch(new ChangeOwnPasswordNow());
   }
}
